<div class="widget-header">
  <h3>Invoice Exports</h3>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="clientId === null || clientId === undefined || clientId <= 0 || submitting"
    (click)="openExportDialog()"
  >
    Export invoices
  </button>
</div>

<div class="mat-elevation-z4 exports-table-container" *ngIf="exports$ | async as exports">
  <table mat-table [dataSource]="exports" *ngIf="exports.length > 0; else emptyState">
    <ng-container matColumnDef="requested_at">
      <th mat-header-cell *matHeaderCellDef>Requested</th>
      <td mat-cell *matCellDef="let row">{{ row.requested_at | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="scope">
      <th mat-header-cell *matHeaderCellDef>Scope</th>
      <td mat-cell *matCellDef="let row">{{ scopeSummary(row) }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        <span class="status-badge status-{{ row.status }}">{{ statusLabel(row) }}</span>
        <span *ngIf="row.status === 'failed' && row.failure_reason" class="failure-reason" [title]="row.failure_reason">
          {{ row.failure_reason }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef>Size</th>
      <td mat-cell *matCellDef="let row">{{ formatSize(row.size_bytes) }}</td>
    </ng-container>

    <ng-container matColumnDef="expires_at">
      <th mat-header-cell *matHeaderCellDef>Expires</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.status === 'ready' && row.expires_at">{{ row.expires_at | date: 'short' }}</span>
        <span *ngIf="row.status === 'expired'">Expired</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button
          mat-button
          color="primary"
          type="button"
          [disabled]="!canDownload(row)"
          (click)="download(row)"
        >
          Download
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <ng-template #emptyState>
    <p class="empty">No exports yet.</p>
  </ng-template>
</div>
